"use client";
//#region packages/@mantine/core/src/components/SegmentedControl/SegmentedControl.module.css
var SegmentedControl_module_default = {
	"root": "m_cf365364",
	"indicator": "m_9e182ccd",
	"label": "m_1738fcb2",
	"input": "m_1714d588",
	"control": "m_69686b9b",
	"innerLabel": "m_78882f40"
};
//#endregion
export { SegmentedControl_module_default as default };

//# sourceMappingURL=SegmentedControl.module.mjs.map